import { jsx as _jsx } from "react/jsx-runtime";
var BrokenLink = function BrokenLink(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "m15.296 13.888-5.171-5.17-1.414 1.414 5.17 5.17 1.415-1.414ZM12 17H5v2h7v-2ZM19 5h-2v7h2V5ZM39.297 37.877l-5.189-5.189-1.414 1.415 5.188 5.188 1.415-1.414ZM31 36h-2v7h2v-7ZM43 29h-7v2h7v-2ZM36.112 25.3l-1.413-1.413 7.113-7.112a7.443 7.443 0 0 0 2.187-5.287C44 7.363 40.637 4 36.512 4c-2 0-3.875.775-5.288 2.188l-7.1 7.1-1.412-1.413 7.087-7.088A9.439 9.439 0 0 1 36.512 2c5.237 0 9.487 4.25 9.487 9.488a9.457 9.457 0 0 1-2.775 6.712l-7.112 7.1ZM11.488 46C6.25 46 2 41.75 2 36.513c0-2.538.987-4.913 2.775-6.713l7.1-7.088 1.412 1.413L6.2 31.212a7.432 7.432 0 0 0-2.2 5.3C4 40.639 7.362 44 11.488 44c2 0 3.875-.775 5.287-2.188l7.113-7.112 1.412 1.412-7.113 7.113a9.428 9.428 0 0 1-6.7 2.775Z",
      fill: color
    })
  });
};
export default BrokenLink;